export default state => ({
  ...state,
  selectedEstimate: '',
  estimateCount: 0,
  containerCount: {},
  itemCount: {},
});
